export { default } from 'features/notifications/routes/notification-inbox-route';
